import React from 'react'

export const linkInlinedStylesheets = (components: React.ReactNode[]) =>
  components.map((component) => {
    const href =
      React.isValidElement<{ 'data-href'?: string }>(component) &&
      component.type === 'style' &&
      component.props['data-href']
    return href ? <link href={href} key={href} rel='stylesheet' /> : component
  })

export const deferredStylesheetsLoaded = () =>
  Promise.all(
    Array.from(
      document.querySelectorAll<HTMLLinkElement>(
        'link[rel="stylesheet"][media="print"][onload]'
      ),
      (link) =>
        new Promise((resolve) => {
          link.addEventListener('load', resolve)
          link.addEventListener('error', resolve)
        })
    )
  )
